import {
  getTimbreDesignAdminPageApi,
  mapTimbreDesignRowToVoiceToneItem,
} from "../../service/timbreDesign";
import {
  cartesian4,
  expandDimForRequest,
  itemMatchesMultiFilters,
  mergeVoiceListsUnique,
  softenDims,
} from "./publicVoiceMultiFetch";

const ADMIN_PAGE_SIZE = 500;

type AdminPageBase = Omit<TimbreDesign.TimbreDesignAdminPageQuery, "username" | "pageNo" | "pageSize">;

async function fetchAdminVoiceAllPagesForParams(
  username: string,
  base: AdminPageBase
): Promise<VoicePublic.VoiceToneItem[]> {
  const u = username.trim();

  const out: VoicePublic.VoiceToneItem[] = [];
  let pageNo = 1;
  let total = 0;
  for (;;) {
    const res = await getTimbreDesignAdminPageApi({
      username: u,
      ...base,
      pageNo,
      pageSize: ADMIN_PAGE_SIZE,
    });
    if (res.code !== 0 || !res.data?.list) break;
    total = Number(res.data.total) || 0;
    const chunk = res.data.list.map(mapTimbreDesignRowToVoiceToneItem);
    out.push(...chunk);
    if (chunk.length === 0 || out.length >= total || chunk.length < ADMIN_PAGE_SIZE) break;
    pageNo += 1;
  }
  return out;
}

/**
 * 系统管理 · 个人音色：`username` 可选，其余与「我的音色」多维筛选一致。
 */
export async function fetchAdminUserVoiceListMulti(
  username: string,
  debouncedVoiceName: string,
  langs: string[],
  genders: string[],
  ages: string[],
  timbres: string[]
): Promise<VoicePublic.VoiceToneItem[]> {
  const u = username.trim();

  const base: AdminPageBase = {};
  if (debouncedVoiceName) base.voiceName = debouncedVoiceName;

  let L = expandDimForRequest(langs);
  let G = expandDimForRequest(genders);
  let A = expandDimForRequest(ages);
  let T = expandDimForRequest(timbres);
  [L, G, A, T] = softenDims(L, G, A, T);

  const combos = cartesian4(L, G, A, T);
  const requests: AdminPageBase[] = combos.map(([l, g, a, t]) => {
    const p: AdminPageBase = { ...base };
    if (l !== undefined) p.langCode = l;
    if (g !== undefined) p.genderValue = g;
    if (a !== undefined) p.ageValue = a;
    if (t !== undefined) p.timbreValue = t;
    return p;
  });

  const lists = await Promise.all(requests.map((p) => fetchAdminVoiceAllPagesForParams(u, p)));
  let merged = mergeVoiceListsUnique(lists);
  merged = merged.filter((item) => itemMatchesMultiFilters(item, langs, genders, ages, timbres));
  return merged;
}
